import React, { useRef, useState } from "react";
import styled from "styled-components";
import { RowElement, RowLayoutStyle } from "../../Sliders/AddSlide";
import { InputField1 } from "../../../InputField1/InputField1";
import Button from "../../../Button/Button";
import { errorMessage } from "../../../../utils/message";
import {
  useAddNewProperty,
  useGetProductList1,
} from "../../../../hooks/useContent";
import Spinner from "react-bootstrap/Spinner";
import Typography from "../../../Typography/Typography";
import { RefreshTableLevelFirst } from "../../../../shared/content-unit";
import { useRecoilState } from "recoil";
import { SimpleSelect1 } from "../../../SimpleSelect/SimpleSelect1";
import { SelectMulti } from "../../../MultiSelect/MultiSelect";

function LevelGenerator() {
  const [refreshEffect, setRefreshEffect] = useRecoilState(
    RefreshTableLevelFirst
  );

  const {
    mutateAsync: addNewProperty,
    isLoading: reqLoading,
    error: reqError,
  } = useAddNewProperty();

  const [newCategory, setNewCategory] = useState({
    title: "",
    label: "",
    en_title: "",
    en_label: "",
    ar_title: "",
    ar_label: "",
    category_id: "",
  });

  const [categoryProperty, setCategoryProperty] = useState([]);

  const handleChange = (e) => {
    const { value, name } = e.target;
    setNewCategory({ ...newCategory, [name]: value });
  };

  const validateForm = () => {
    if (newCategory.title.length < 1) {
      errorMessage("لطفا نام فارسی دسته بندی را وارد کنید");
      return false;
    } else if (newCategory.label.length < 1) {
      errorMessage("لطفا نام فارسی لیبل را وارد کنید");
      return false;
    }
    return true;
  };

  const { data: listProduct, isLoading: loadingCategorty } =
    useGetProductList1("");

  const initialListProduct = listProduct?.data?.categories?.map((item) => ({
    label: item?.NameCategories,
    value: item?.IdCategories,
  }));

  const handleSubmit = () => {
    if (validateForm()) {
      addNewProperty(newCategory).then((res) => {
        setRefreshEffect(!refreshEffect);
        setNewCategory({
          title: "",
          label: "",
          en_title: "",
          en_label: "",
          ar_title: "",
          ar_label: "",
          category_id: "",
        });
        selectRef.current.value = [];
        setCategoryProperty([]);
      });
    }
  };

  const selectRef = useRef();

  return (
    <LevelGeneratorStyle>
      <GeneratorWrapper>
        <RowLayoutStyle>
          <RowElement>
            <InputField1
              type="text"
              name="title"
              label="نام فارسی"
              onChange={handleChange}
              value={newCategory?.title}
              placeholder="نام فارسی دسته بندی.."
              maxLenght="50"
            />
          </RowElement>
          <RowElement>
            <InputField1
              type="text"
              name="en_title"
              label="نام انگلیسی"
              onChange={handleChange}
              value={newCategory?.en_title}
              placeholder="نام انگلیسی دسته بندی..."
              maxLenght="50"
            />
          </RowElement>
          <RowElement>
            <InputField1
              type="text"
              name="ar_title"
              label="نام عربی"
              onChange={handleChange}
              value={newCategory?.ar_title}
              placeholder="نام دسته بندی عربی ..."
              maxLenght="50"
            />
          </RowElement>
        </RowLayoutStyle>
        <RowLayoutStyle>
          <RowElement>
            <InputField1
              type="text"
              name="label"
              label="نام لیبل"
              onChange={handleChange}
              value={newCategory?.label}
              placeholder="لیبل"
              maxLenght="50"
            />
          </RowElement>
          <RowElement>
            <InputField1
              type="text"
              name="en_label"
              label="لیبل انگلیسی"
              onChange={handleChange}
              value={newCategory?.en_label}
              placeholder="نام لیبل انگلیسی"
              maxLenght="50"
            />
          </RowElement>
          <RowElement>
            <InputField1
              type="text"
              name="ar_label"
              label="لیبل عربی"
              onChange={handleChange}
              value={newCategory?.ar_label}
              placeholder="نام لیبل عربی"
              maxLenght="50"
            />
          </RowElement>
          <RowElement>
            <SelectMulti
              label="دسته بندی محصول"
              inputRef={selectRef}
              value={categoryProperty}
              res={initialListProduct}
              onChange={(e) => {
                setNewCategory({
                  ...newCategory,
                  category_id: Array.isArray(e) ? e.map((x) => x.value) : [],
                });
                setCategoryProperty(e);
              }}
            />
          </RowElement>
        </RowLayoutStyle>

        <Button
          bgColor={"#4c78a9"}
          small={"200px"}
          onclick={(e) => {
            !reqLoading && handleSubmit();
          }}
          color="#fff"
        >
          {reqLoading ? (
            <Spinner animation="border" size="sm" />
          ) : (
            <Typography size={"15px"} primary={"#fff"}>
              ثبت ویژگی
            </Typography>
          )}
        </Button>
      </GeneratorWrapper>
    </LevelGeneratorStyle>
  );
}

const LevelGeneratorStyle = styled.div``;

const GeneratorWrapper = styled.div`
  width: 100%;
  padding: 1rem 2rem;
  background-color: ${({ theme }) => theme.backgroundSidebar};
`;

export default LevelGenerator;
